import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";

import { Typography } from "@mui/material";

import { WithTypeSelection as AddChangeOrder } from "./AddChangeOrder";
import ListChangeOrders from "./ListChangeOrders";
import ViewChangeOrder from "./ViewChangeOrder";
import HiddenOn from "components/Wrappers/HiddenOn";
import { isHomeOwner, isTeamMember } from "core/utils/roleUtils";

// Container page for Change Orders (analogous to Invoice page)
export const Wrapper = (props) => {
  const dispatch = useDispatch();
  const { type } = props; // type can be 'builder', 'supplier', 'homeowner', etc.
  const [openAddChangeOrder, setOpenAddChangeOrder] = useState(false);
  const [editChangeOrderData, setEditChangeOrderData] = useState(null);
  const [viewChangeOrder, setViewChangeOrder] = useState(false);
  const [clickedChangeOrder, setClickedChangeOrder] = useState(null);

  const handleAdd = () => {
    setEditChangeOrderData(null);
    setOpenAddChangeOrder(true);
  };

  const onRowClick = useCallback((row, clickType) => {
    if (clickType === "view") {
      setViewChangeOrder(true);
      setClickedChangeOrder(row);
    } else {
      setEditChangeOrderData(row);
      setOpenAddChangeOrder(true);
    }
  }, []);

  const handleClose = () => {
    setOpenAddChangeOrder(false);
    setEditChangeOrderData(null);
    dispatch({
      type: "CLEAR_CHANGE_ORDER_DATA",
    });
  };

  if (openAddChangeOrder) {
    return (
      <AddChangeOrder
        changeOrderId={editChangeOrderData?.changeOrderId}
        type={type}
        selectedChangeOrder={
          editChangeOrderData
            ? {
                changeOrderId: editChangeOrderData.changeOrderId,
                data: editChangeOrderData,
              }
            : {}
        }
        onClose={handleClose}
        {...props}
      />
    );
  }

  if (viewChangeOrder) {
    return (
      <ViewChangeOrder
        type={type}
        changeOrder={clickedChangeOrder}
        {...props}
        onClose={() => {
          setViewChangeOrder(false);
        }}
      />
    );
  }

  return (
    <div className="change-order-container p-2 m-2">
      {" "}
      {/* reusing existing layout styles */}
      <div className="d-flex justify-content-between ">
        <Typography className="h2">Change Orders</Typography>
        <HiddenOn
          isHidden={
            isTeamMember(props?.appRoleDetails) ||
            isHomeOwner(props?.appRoleDetails)
          }
        >
          <div className="change-order-header justify-content-end">
            <button className="primaryButton" type="button" onClick={handleAdd}>
              + Add Change Order
            </button>
          </div>
        </HiddenOn>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <ListChangeOrders
          onRowClick={(row, clickType) => onRowClick(row, clickType)}
          type={type}
          {...props}
        />
      </div>
    </div>
  );
};

export default Wrapper;
